import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import UnitFileLine from '../entities/unit-file-line'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import Util from '@/lib/util';
import appconst from './../../lib/appconst';

interface UnitImportState extends ListState<UnitFileLine> {
    itemsImported: Array<UnitFileLine>,
    countItems : number,
    countImportedItems: number
}
class UnitImportModule extends ListModule<UnitImportState, any, UnitFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<UnitFileLine>(),
        loading: false,
        itemsImported: new Array<UnitFileLine>(),
        countItems:0,
        countImportedItems:0
    }
    actions = {
        async getAll(context: ActionContext<UnitImportState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/UnitFile/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<UnitFileLine>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async uploadImportUnitFile(context: ActionContext<UnitImportState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/UnitFile/ImportUnit', data);
            return reponse.data.result
        },
        async export(context:ActionContext<UnitImportState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportUnits/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: UnitImportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: UnitImportState, pagesize: number) {
            state.pageSize = pagesize;
        },
        processNotifier(state: UnitImportState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    let unitLine = payload.data.data as UnitFileLine;
                    state.itemsImported.unshift(unitLine);
                }
                if (payload.data.countItems != undefined && payload.data.countItems != null) {
                    state.countItems = payload.data.countItems as number;
                }
                if (payload.data.countImportedItems != undefined && payload.data.countImportedItems != null) {
                    state.countImportedItems = payload.data.countImportedItems as number;
                }
            }
        },
        resetList(state: UnitImportState) {
            state.itemsImported = new Array<UnitFileLine>();
        },
        pageChangeItemsImported(state: UnitImportState) {
            state.list = Util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const unitImportModule = new UnitImportModule();
export default unitImportModule;